import React from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import TextButton from '@wix/da-ds/pkg/Buttons/TextButton';
import { getSeeAllBI } from '../../helpers';
import s from './SeeAllLink.scss';
const SeeAllLink = ({ contentType , deviation , type , url , className , onClick  })=>{
    const { t  } = useTranslation();
    return /*#__PURE__*/ React.createElement(TextButton, {
        className: classnames(s['root'], className),
        variant: "main",
        size: "small",
        href: url,
        onClick: onClick,
        biData: getSeeAllBI(contentType, deviation)
    }, t([
        `sidebar.${type}.${contentType}`,
        `sidebar.${type}`
    ]));
};
SeeAllLink.displayName = 'SeeAllLink';
export default SeeAllLink;
